import React from 'react';
import { Form, Input, InputNumber, DatePicker, Select, Tooltip, Button, Popconfirm, message } from 'antd';
import moment from 'moment';
import Cookies from 'js-cookie';
import { moneyAddComma, handleDeepCopy } from '../../../../../utils';
import ModalDom from '../../../../../components/Modal';
import { CustomRow, CustomCol } from '../../../../../components/Custom';
import { checkOutType, backMoneyType, receivablesMoneyType } from '../../../../../axios/dictionaries';
import { post, config, postFrom } from '../../../../../axios';

const Option = Select.Option;

moneyAddComma(20100 - 19830.99)

class Page extends React.Component {
    constructor() {
        super();

        this.initState = {
            loading: false,
            data: {},
            departmentData: [], //商户下的部门
            userData: [], //部门下的人员
            refundData: [], //退款
            refundType: [ //退款类别
            ],
            receivablesData: [], //收款
            receivablesType: [ //收款类别
            ],
            endPayType: 1, //退款方式
        };
        this.state = {
            ...handleDeepCopy(this.initState),
        };
    }

    handleCancel = () => { //关闭页面
        this.setState({ ...handleDeepCopy(this.initState) }, () => {
            this.props.handleCancel();
        });
    }

    handleRefundMinus = (index) => {
        let { refundData } = this.state;
        refundData.splice(index, 1);
        this.setState({ refundData });
    }

    handleReceivablesMinus = (index) => {
        let { receivablesData } = this.state;
        receivablesData.splice(index, 1);
        this.setState({ receivablesData });
    }

    disposeBillManual = (lastItem, nextItem) => { //处理手动添加的【收款/退款】账单数据
        return {
            key: lastItem ? lastItem.key + 1 : 0,
            feeName: nextItem ? nextItem.dicValue : "",
            billBeginDate: moment(),
            billEndDate: moment(),
            billMoney: 0,
            receivedMoney: 0,
            feeRemark: ''
        }
    }

    handleRefundPlus = () => {
        let { refundData, refundType } = this.state;
        let lastItem = [].concat(refundData).sort((a, b) => b.key - a.key)[0]; //最大的key(用来设置新增的数据key)
        let nextItem = refundType[refundData.filter(item => !item.id).length]; //表示下一条类型的账单
        refundData.push(this.disposeBillManual(lastItem, nextItem ? nextItem : refundType[0]));
        this.setState({ refundData });
    }

    handleReceivablesPlus = () => {
        let { receivablesData, receivablesType } = this.state;
        let lastItem = [].concat(receivablesData).sort((a, b) => b.key - a.key)[0] //最大的key(用来设置新增的数据key)
        let nextItem = receivablesType[receivablesData.filter(item => !item.id).length]; //表示下一条类型的账单
        receivablesData.push(this.disposeBillManual(lastItem, nextItem ? nextItem : receivablesType[0]));
        this.setState({ receivablesData });
    }

    disposeBill = (data, lastKey = 0) => { //处理从接口获取到的【收款/退款】账单数据
        return data instanceof Array
            ? data.map((item, index) => {
                return {
                    id: item.id,
                    key: lastKey + index,
                    feeName: item.feeName,
                    billBeginDate: item.billBeginDate ? moment(item.billBeginDate) : undefined,
                    billEndDate: item.billEndDate ? moment(item.billEndDate) : undefined,
                    billMoney: item.billMoney,
                    receivedMoney: item.receivedMoney,
                    countMoney:item.billMoney -item.receivedMoney , //前端计算的字段
                    feeRemark: item.feeRemark,
                }
            })
            : [];
    }

    handleGetDetail = () => { //获取详情
        this.setState({ loading: true });
        postFrom({ url: config.API_rentcontract_getEndVo, data: { contractId: this.rentContractId } }).then(res => {
            let refundData = this.disposeBill(res.payBillList); //处理退款账单
            let receivablesData = this.disposeBill(res.receivableBillList);  //处理收款账单
            this.setState({ loading: false, data: res, refundData, receivablesData });
        }).catch(err => {
            message.error(err.message || '获取合同详情失败');
            this.setState({ loading: false });
        })
    }

    handleGetResetDetail = (factEndDate) => { //刷新详情
        this.setState({ loading: true });
        postFrom({ url: config.API_rentcontract_getReceivableBillList, data: { contractId: this.rentContractId, factEndDate } }).then(res => {
            let { receivablesData } = this.state;
            let useReceivablesData = receivablesData.filter((item) => !item.id); //在现有的收款账单中筛选出自己填写的
            let lastItem = [].concat(useReceivablesData).sort((a, b) => b.key - a.key)[0]; //最后一条元素
            let newReceivablesData = this.disposeBill(res, lastItem ? lastItem.key + 1 : 0); //处理新的收款账单
            this.setState({ loading: false, receivablesData: newReceivablesData.concat(useReceivablesData) });
        }).catch(err => {
            message.error(err.message || '刷新账单失败');
            this.setState({ loading: false });
        })
    }

    handleGetDepartment = () => { //获取当前商户的部门
        postFrom({ url: config.API_merchantdepartment_findAll, data: { merchantId: this.loginData.merchantId || 0 } }).then(res => {
            this.setState({ departmentData: res });
        }).catch(err => {
            message.error(err.message || '获取部门列表失败');
        })
    }

    handleGetUser = (departmentId) => { //获取当前部门下的人员
        let data = {};
        if (this.loginData.merchantId) {
            data = {
                merchantId: this.loginData.merchantId,
                merchantUserId: this.loginData.id,
                merchantDepartmentId: departmentId || this.loginData.departmentId,
            }
        }
        postFrom({ url: config.API_merchantuser_findList, data }).then(res => {
            this.setState({ userData: res });
        }).catch(err => {
            message.error(err.message || '获取人员列表失败');
        })
    }

    handleDicType = () => {
        postFrom({ url: config.API_dictionary_findList, data: { groupName: '退款类别' } }).then(res => {
            this.setState({ refundType: res });
        }).catch(err => {
            message.error(err.message || '获取退款类别失败');
        });
        postFrom({ url: config.API_dictionary_findList, data: { groupName: '收款类别' } }).then(res => {
            this.setState({ receivablesType: res });
        }).catch(err => {
            message.error(err.message || '获取收款类别失败');
        });
    }

    loadPack = ({ id = 9 }) => {
        if (this.loginData) {
            this.rentContractId = id;
            this.handleGetDetail();
            this.handleGetDepartment();
            this.handleGetUser();
            this.handleDicType();
        } else {
            message.error('未登录！');
        }
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                values.factEndDate = values.factEndDate ? values.factEndDate.format('YYYY-MM-DD') : '';
                values.endHandleDate = values.endHandleDate ? values.endHandleDate.format('YYYY-MM-DD') : '';
                values.endAmount = Number((this.receivablesMoney - this.refundMoney).toFixed(2));
                values.rentContractId = this.rentContractId;

                // 提取出新增的付款、收款账单
                let { refundData, receivablesData } = this.state;
                values.payList = refundData.map(item => {
                    return {
                        id: item.id || 0,
                        feeName: item.feeName,
                        billBeginDate: item.billBeginDate.format('YYYY-MM-DD'),
                        billEndDate: item.billEndDate.format('YYYY-MM-DD'),
                        receivedMoney: item.receivedMoney,
                        billMoney: item.billMoney,
                        feeRemark: item.feeRemark,
                    }
                });
                values.receiveList = receivablesData.map(item => {
                    return {
                        id: item.id || 0,
                        feeName: item.feeName,
                        billBeginDate: item.billBeginDate.format('YYYY-MM-DD'),
                        billEndDate: item.billEndDate.format('YYYY-MM-DD'),
                        billMoney: item.countMoney, //item.billMoney -item.receivedMoney , //前端计算的字段
                        feeRemark: item.feeRemark,
                    }
                });

                post({ url: config.API_rentcontract_endContract, data: values }).then(res => {
                    message.success('退租成功');
                    this.props.handleGetList();
                    this.handleCancel();
                }).catch(err => {
                    message.error(err.message || '退租失败');
                    this.setState({ loading: false });
                })
            }
        })
    }

    componentDidMount() {
        this.props.onRef(this);
        let loginData = Cookies.get('loginData');
        if (loginData) {
            this.loginData = JSON.parse(loginData);
        }
    }

    render() {
        let { visible, form: { getFieldDecorator, getFieldValue } } = this.props;
        let {
            loading,
            data,
            departmentData,
            userData,
            refundData,
            refundType,
            receivablesData,
            receivablesType,
            endPayType,
        } = this.state;

        let refundMoney = refundData.length ? refundData.reduce((total, item) => total + item.receivedMoney, 0) : 0;
        let receivablesMoney = receivablesData.length ? receivablesData.reduce((total, item) => total + item.countMoney, 0) : 0;
        this.refundMoney = refundMoney;
        this.receivablesMoney = receivablesMoney;

        return <ModalDom
            title="退租"
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form>
                    <CustomRow title="房源">
                        <CustomCol label="小区楼栋" required={false}>
                            <span className="not-edit">{data.nowBuildingName}</span>
                        </CustomCol>
                        <CustomCol label="房号" required={false}>
                            <span className="not-edit">{data.nowRoomNo}</span>
                        </CustomCol>
                    </CustomRow>
                    <div className="hr"></div>
                    <CustomRow title="租客" divider>
                        <CustomCol label="姓名" required={false}>
                            <span className="not-edit">{data.nowCustomerName}</span>
                        </CustomCol>
                        <CustomCol label="证件号码" required={false}>
                            <span className="not-edit">{data.nowCredentialNumber}</span>
                        </CustomCol>
                        <CustomCol label="手机号码" required={false}>
                            <span className="not-edit">{data.nowCustomerPhone}</span>
                        </CustomCol>
                    </CustomRow>
                    <div className="hr"></div>
                    <CustomRow title="合同" divider>
                        <CustomCol label="起租日" required={false}>
                            <span className="not-edit">{data.beginDate ? moment(data.beginDate).format('YYYY-MM-DD') : ''}</span>
                        </CustomCol>
                        <CustomCol label="到期日" required={false}>
                            <span className="not-edit">{data.endDate ? moment(data.endDate).format('YYYY-MM-DD') : ''}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow title={true} divider>
                        <CustomCol label="房间物品" required={false} labelStyle={{ height: '100px' }} colStyle={{ width: '800px', height: '100px' }}>
                            <span className="not-edit">
                                {
                                    data.furnitureList instanceof Array
                                        ?
                                        data.furnitureList.map((item, index) => {
                                            return `${item.name}${item.amount > 1 ? 'X' + item.amount : ''}${index < data.furnitureList.length - 1 ? '、' : ''}`
                                        })
                                        : '无登记物品'
                                }
                            </span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider></CustomRow>
                    <div className="hr"></div>
                    <CustomRow divider></CustomRow>
                    <CustomRow title="结算" divider>
                        <CustomCol label="退租日">
                            {getFieldDecorator('factEndDate', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: moment()
                            })(
                                <DatePicker
                                    allowClear={false}
                                    onChange={(...args) => {
                                        this.handleGetResetDetail(args[1])
                                    }}
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="退租类型">
                            {getFieldDecorator('endType', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.endType || 1
                            })(
                                <Select
                                    showSearch
                                    placeholder="请选择"
                                    optionFilterProp={'children'}
                                >
                                    {checkOutType.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow title={true} divider>
                        <div className="tableBox" style={{ flex: 1 }}>
                            <div className="tableTitle">
                                <div style={{ flex: 1 }} className="xinxin xinxinColor">退款类别</div>
                                <div style={{ flex: 2 }} className="xinxin xinxinColor">账单周期</div>
                                <div style={{ flex: 1 }} className="xinxin xinxinColor">应退金额（元）</div>
                                <div style={{ flex: 2 }}>说明</div>
                                <div style={{ flex: '0 0 100px' }}>操作</div>
                            </div>
                            <div className="tableBody">
                                {
                                    refundData.map((item, index) => {
                                        return <div className="tableBodyRow" key={item.key}>
                                            <div style={{ flex: 1 }}>
                                                <Select
                                                    placeholder="请选择"
                                                    defaultValue={item.feeName}
                                                    onChange={(value) => {
                                                        refundData[index].feeName = value;
                                                        this.setState({ refundData });
                                                    }}
                                                    disabled={Boolean(item.id)}
                                                >
                                                    {refundType.map((item, index) => <Option value={item.dicValue} key={index}>{item.dicValue}</Option>)}
                                                </Select>
                                            </div>
                                            <div style={{ flex: 2 }}>
                                                <DatePicker
                                                    className="data-picker-center"
                                                    placeholder="请输入"
                                                    allowClear={false}
                                                    suffixIcon={<span></span>}
                                                    defaultValue={item.billBeginDate ? item.billBeginDate : undefined}
                                                    onChange={(value) => {
                                                        refundData[index].billBeginDate = value;
                                                        this.setState({ refundData });
                                                    }}
                                                    disabled={Boolean(item.id)}
                                                />
                                                <span style={{ padding: '0 5px', height: '100%', lineHeight: '34px', background: Boolean(item.id) ? '#f5f5f5' : '' }}>至</span>
                                                <DatePicker
                                                    className="data-picker-center"
                                                    placeholder="请输入"
                                                    allowClear={false}
                                                    suffixIcon={<span></span>}
                                                    defaultValue={item.billEndDate ? item.billEndDate : undefined}
                                                    onChange={(value) => {
                                                        refundData[index].billEndDate = value;
                                                        this.setState({ refundData });
                                                    }}
                                                    disabled={Boolean(item.id)}
                                                />
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <InputNumber
                                                    style={{ paddingRight: '25px' }}
                                                    className="money-right"
                                                    min={0}
                                                    defaultValue={item.receivedMoney}
                                                    precision={2}
                                                    onChange={(value) => {
                                                        refundData[index].receivedMoney = value;
                                                        this.setState({ refundData });
                                                    }}
                                                    disabled={Boolean(item.id)}
                                                />
                                            </div>
                                            <div style={{ flex: 2 }}>
                                                <Input
                                                    autoComplete={'off'}
                                                    defaultValue={item.feeRemark}
                                                    onChange={(e) => {
                                                        refundData[index].feeRemark = e.target.value;
                                                        this.setState({ refundData });
                                                    }}
                                                    disabled={Boolean(item.id)}
                                                />
                                            </div>
                                            <div style={Boolean(item.id) ? { backgroundColor: '#f5f5f5', cursor: 'not-allowed', flex: '0 0 100px' } : { flex: '0 0 100px' }}>
                                                {
                                                    Boolean(item.id)
                                                        ? <span>-</span>
                                                        : <Popconfirm
                                                            placement="topRight"
                                                            title={'此删除操作不可恢复，确定删除吗？'}
                                                            onConfirm={() => {
                                                                this.handleRefundMinus(index)
                                                            }}
                                                            okText="删除"
                                                            cancelText="取消"
                                                        >
                                                            <span className="showClickDetail">删除</span>
                                                        </Popconfirm>
                                                }
                                            </div>
                                        </div>
                                    })
                                }
                                <div className="tableBodyRow" style={{ justifyContent: 'space-between', alignItems: 'center', height: '34px', padding: '0 35px 0 20px' }}>
                                    <span>退款：<span style={{ color: 'red' }}>{moneyAddComma(refundMoney)}</span>元</span>
                                    <Tooltip placement="bottomLeft" title={"添加一行退款输入框"}>
                                        <Button onClick={this.handleRefundPlus} style={{ width: '24px', height: '24px', lineHeight: '16px', fontSize: '14px' }} shape="circle" icon="plus" />
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </CustomRow>
                    <CustomRow title={true} divider>
                        <div className="tableBox" style={{ flex: 1 }}>
                            <div className="tableTitle">
                                <div style={{ flex: 1 }} className="xinxin xinxinColor">收款类别</div>
                                <div style={{ flex: 2 }} className="xinxin xinxinColor">账单周期</div>
                                <div style={{ flex: 1 }} className="xinxin xinxinColor">未收金额（元）</div>
                                <div style={{ flex: 2 }}>说明</div>
                                <div style={{ flex: '0 0 100px' }}>操作</div>
                            </div>
                            <div className="tableBody">
                                {
                                    receivablesData.map((item, index) => {
                                        // 如果是系统已经生成的账单
                                        let disabled = item.id && moment(getFieldValue('factEndDate').format('YYYY-MM-DD')).diff(moment(item.billEndDate.format('YYYY-MM-DD')), 'days') >= 0;
                                        return <div className="tableBodyRow" key={item.key}>
                                            <div style={{ flex: 1 }}>
                                                <Select
                                                    placeholder="请选择"
                                                    defaultValue={item.feeName}
                                                    onChange={(value) => {
                                                        receivablesData[index].feeName = value;
                                                        this.setState({ receivablesData });
                                                    }}
                                                    disabled={Boolean(item.id)}
                                                >
                                                    {receivablesType.map((item, index) => <Option value={item.dicValue} key={index}>{item.dicValue}</Option>)}
                                                </Select>
                                            </div>
                                            <div style={{ flex: 2 }}>
                                                <DatePicker
                                                    className="data-picker-center"
                                                    placeholder="请输入"
                                                    allowClear={false}
                                                    suffixIcon={<span></span>}
                                                    defaultValue={item.billBeginDate ? item.billBeginDate : undefined}
                                                    onChange={(value) => {
                                                        receivablesData[index].billBeginDate = value;
                                                        this.setState({ receivablesData });
                                                    }}
                                                />
                                                <span style={{ padding: '0 5px', height: '100%', lineHeight: '34px', background: disabled ? '#f5f5f5' : '' }}>至</span>
                                                <DatePicker
                                                    className="data-picker-center"
                                                    placeholder="请输入"
                                                    allowClear={false}
                                                    suffixIcon={<span></span>}
                                                    defaultValue={item.billEndDate ? item.billEndDate : undefined}
                                                    onChange={(value) => {
                                                        receivablesData[index].billEndDate = value;
                                                        this.setState({ receivablesData });
                                                    }}
                                                />
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <InputNumber
                                                    style={{ paddingRight: '25px' }}
                                                    className="money-right"
                                                    min={0}
                                                    defaultValue={item.countMoney}
                                                    precision={2}
                                                    onChange={(value) => {
                                                        receivablesData[index].countMoney = value;
                                                        this.setState({ receivablesData });
                                                    }}
                                                />
                                            </div>
                                            <div style={{ flex: 2 }}>
                                                <Input
                                                    autoComplete={'off'}
                                                    defaultValue={item.feeRemark}
                                                    onChange={(e) => {
                                                        receivablesData[index].feeRemark = e.target.value;
                                                        this.setState({ receivablesData });
                                                    }}
                                                />
                                            </div>
                                            <div style={{ flex: '0 0 100px' }}>
                                                {
                                                    <Popconfirm
                                                        placement="topRight"
                                                        title={'此删除操作不可恢复，确定删除吗？'}
                                                        onConfirm={() => {
                                                            this.handleReceivablesMinus(index)
                                                        }}
                                                        okText="删除"
                                                        cancelText="取消"
                                                    >
                                                        <span className="showClickDetail">删除</span>
                                                    </Popconfirm>
                                                }
                                            </div>
                                        </div>
                                    })
                                }
                                <div className="tableBodyRow" style={{ justifyContent: 'space-between', alignItems: 'center', height: '34px', padding: '0 35px 0 20px' }}>
                                    <span>收款：<span style={{ color: 'red' }}>{moneyAddComma(receivablesMoney)}</span>元</span>
                                    <Tooltip placement="bottomLeft" title={"添加一行收款输入框"}>
                                        <Button onClick={this.handleReceivablesPlus} style={{ width: '24px', height: '24px', lineHeight: '16px', fontSize: '14px' }} shape="circle" icon="plus" />
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </CustomRow>
                    <CustomRow title={true} divider>
                        <div style={{ padding: '10px 0 0', lineHeight: 1 }}>收款合计：<span style={{ color: 'red', fontWeight: 600 }}>{moneyAddComma(receivablesMoney - refundMoney)}</span>元</div>
                    </CustomRow>
                    <CustomRow title={true} divider>
                        {
                            receivablesMoney - refundMoney > 0
                                ? <CustomCol label="收款方式">
                                    {getFieldDecorator('endReceiveType', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.endReceiveType || 1
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {receivablesMoneyType.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                : <React.Fragment>
                                    <CustomCol label="退款方式">
                                        {getFieldDecorator('endPayType', {
                                            rules: [{
                                                required: true, message: '请输入',
                                            }],
                                            initialValue: data.endPayType || 1
                                        })(
                                            <Select
                                                showSearch
                                                placeholder="请选择"
                                                optionFilterProp={'children'}
                                                onChange={(value) => {
                                                    this.setState({ endPayType: value })
                                                }}
                                            >
                                                {backMoneyType.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                            </Select>
                                        )}
                                    </CustomCol>
                                    {
                                        endPayType === 1 || endPayType === 2 || endPayType === 3
                                            ? <CustomCol label="账号信息" colStyle={{ width: '500px' }}>
                                                {getFieldDecorator('endPayAccount', {
                                                    rules: [{
                                                        required: true, message: '请输入',
                                                    }],
                                                    initialValue: data.endPayAccount
                                                })(
                                                    <Input
                                                        autoComplete={'off'}
                                                    />
                                                )}
                                            </CustomCol>
                                            : null
                                    }
                                </React.Fragment>
                        }
                    </CustomRow>
                    <div className="hr"></div>
                    <CustomRow title="办理" divider>
                        <CustomCol label="办理部门">
                            {getFieldDecorator('endDepartmentId', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: this.loginData ? this.loginData.departmentId : data.endDepartmentId
                            })(
                                <Select
                                    showSearch
                                    placeholder="请选择"
                                    optionFilterProp={'children'}
                                    onChange={(value) => {
                                        this.handleGetUser(value)
                                    }}
                                >
                                    {departmentData.map((item, index) => <Option value={item.id} key={item.id}>{item.name}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                        <CustomCol label="办理人">
                            {getFieldDecorator('endUserId', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: this.loginData ? this.loginData.id : data.endUserId
                            })(
                                <Select
                                    showSearch
                                    placeholder="请选择"
                                    optionFilterProp={'children'}
                                >
                                    {userData.map((item, index) => <Option value={item.id} key={item.id}>{item.name}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                        <CustomCol label="办理日期">
                            {getFieldDecorator('endHandleDate', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: data.endHandleDate ? moment(data.endHandleDate) : moment()
                            })(
                                <DatePicker />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow title={true} divider>
                        <CustomCol label="办理备注" required={false} colStyle={{ width: '800px' }}>
                            {getFieldDecorator('endHandleRemark', {
                                initialValue: data.endHandleRemark
                            })(
                                <Input
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                </Form>
            </div>
        </ModalDom>
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/RentContract/components/List/CheckOut/index.js